export function getTeamByShortName(shortname) {
    const { teams } = this.props
    return Object.keys(teams).find(team => teams[team].shortname === shortname)
}

export function getTeamIdByShortName(shortname) {
    const team = getTeamByShortName.call(this, shortname)
    return team ? team.id : null
}

export const mappedEmails = (selected, selectedEmail) => (
    Object.keys(selected.items)
        .map(team => selected.items[team][selectedEmail])
)

export const searchEmailsForCurrentEmail = (mappedEmails, invitedEmail) => (
    mappedEmails.find(email => email === invitedEmail)
)

export const isTeamAdmin = (teamId, profile) => {
    const membership = Object.keys(profile.memberships)
        .map(k => profile.memberships[k])
        .find(m => m.teamId === teamId)
    return membership && membership.accessLevel === "Admin"
}


// WEBPACK FOOTER //
// ./src/util/team_utils.js